import { createContext, useContext } from 'react';

import type { EditorContentUnifiedQuery$data } from './__generated__/EditorContentUnifiedQuery.graphql.ts';

export type EditorContentNode = NonNullable<
	NonNullable<NonNullable<EditorContentUnifiedQuery$data['content']>['nodes']>[number]
>;

export const EditorContentNodeContext: React.Context<EditorContentNode | null> =
	createContext<EditorContentNode | null>(null);

// Null outside EditorContentContainer (experiment off or not an editor route) and when the operation
// returns no node.
export const useEditorContentNode = (): EditorContentNode | null =>
	useContext(EditorContentNodeContext);
